// extracted by mini-css-extract-plugin
export default {"popupContent":"styles_popupContent__I-o2w","discountCircle":"styles_discountCircle__Apzcj","promocode":"styles_promocode__dumwc"};